import React from 'react'
import { useState } from 'react'
import { responseError } from '../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../UI/messages/ErrorMessage'
import MyButton from '../../UI/form/MyButton'
import { changeWorkLinePlaceAPI } from '../../../api/workLinePlace/workLinePlaceAPI'

const WorkLinePlaceConfirm = ({ scaned, setOpen }) => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const endWorkLinePlace = () => {
        setError('')
        setLoading(true)
        changeWorkLinePlaceAPI({ scaned }).then(data => {
            setLoading(false)
            setOpen(false)

            // Оновлюємо сторінку щойно відбулась фіксація на робочому місці
            window.location.reload();
        }).catch(e => {
            setError(responseError(e))
            // setErrorMain(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div>
        <ErrorMessage
            error={error}
        />

        {
            scaned ?
                <MyButton
                    onClick={endWorkLinePlace}
                    disabled={loading ? true : false}
                >
                    Підтвердити
                </MyButton>
            : ''
        }
    </div>
  )
}

export default WorkLinePlaceConfirm